
export interface ICard {
    id: string;
    user_id: string;
    card_type: CardType;
    card_product_id: string;
    reference_card_id: string;
    bulk_issuance_id: string;
    name_on_card: string;
    shipping_details: IShipping;
    status: CardStatus;
    status_reason: CardStatusReason;
    fulfillment_status: FulfillmentStatus;
    bin: string;
    last_four: string;
    expiry_date: string | number;
    pin_retries: number;
    proxy_number: string;
    created: string;
    modified: string;
    extra_embossing_line: string;
    card_soft_expiry: string;
    card_product_name: string;
    auth_settings: ICardAuth;
    credit_settings: ICreditSettings;
    ledger_balances: IBalance;
    currencies: string[];
    is_account_linked: boolean;
    modified_by: string;
    user_name?: string;
    account_id?: string;
    delivery_payment_mode?: string;
}

export enum CardType {
    PHYSICAL = 'PHYSICAL',
    VIRTUAL = 'VIRTUAL',
}

export enum RiyadhCardType {
    PREPAID = 'PREPAID',
    CREDIT = 'CREDIT',
}

export enum CardStatus {
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    TERMINATED = 'TERMINATED',
}

export enum CardStatusEnum {
    INACTIVE = 'Inactive',
    ACTIVE = 'Active',
    SUSPENDED = 'Suspended',
    TERMINATED = 'Terminated',
}

export enum CardStatusReason {
    I0 = 'I0',
    I1 = 'I1',
    I2 = 'I2',
    I3 = 'I3',
    A0 = 'A0',
    A1 = 'A1',
    A2 = 'A2',
    A3 = 'A3',
    AT = 'AT',
    S0 = 'S0',
    S1 = 'S1',
    S2 = 'S2',
    S3 = 'S3',
    S4 = 'S4',
    S5 = 'S5',
    S6 = 'S6',
    S7 = 'S7',
    ST = 'ST',
    T0 = 'T0',
    T1 = 'T1',
    T2 = 'T2',
    T3 = 'T3',
    T4 = 'T4',
    T5 = 'T5',
    T6 = 'T6',
    T7 = 'T7',
    T8 = 'T8',
    T9 = 'T9',
    T10 = 'T10',
    T11 = 'T11',
    T12 = 'T12',
    T13 = 'T13',
    T14 = 'T14',
    T15 = 'T15',
    T16 = 'T16',
    T17 = 'T17',
    T18 = 'T18',
    P0 = 'P0',
    R0 = 'R0',
}

export enum FulfillmentStatus {
    CREATED = 'CREATED',
    ORDERED = 'ORDERED',
    DELIVERED = 'DELIVERED',
    REJECTED = 'REJECTED',
    DISPATCHED = 'DISPATCHED',
    FULFILLED = 'FULFILLED',
}

export interface ICreditSettings {
    next_due_date: string;
    assignedCreditLimit: number;
    type: string;
}

export enum CardShippingMethod {
    COURIER = 'COURIER',
}

export interface IShipping {
    method: CardShippingMethod;
    return_address: IShippingAddress;
    shipping_address: IShippingAddress;
}

export interface IShippingAddress {
    first_name: string;
    middle_name: string;
    last_name: string;
    mobile: string;
    address_line1: string;
    address_line2: string;
    city: string;
    state: string;
    country: string;
    postal_code: string;
    street: string;
    nearest_place: string;
}

export interface ICardAuth {
    allow_atm: boolean;
    allow_pos: boolean;
    allow_chip: boolean;
    allow_magstripe: boolean;
    allow_chip_fallback: boolean;
    allow_without_pin: boolean;
    allow_ecommerce_non_3DS: boolean;
    allow_ecommerce_3DS: boolean;
    allow_ecommerce_without_CVV: boolean;
    allow_account_verification_without_CVV: boolean;
    allow_quasi_cash: boolean;
    allow_scheme_account_funding: boolean;
    allow_scheme_credits: boolean;
    allow_contactless: boolean;
    allowed_mccs_id: string;
    allowed_countries_id: string;
}

export interface IBalance {
    [key: string]: number;
}

export interface ICardStatusChange {
    status: string;
    status_reason_code?: string;
    fulfillment_status?: string;
    comment: string;
    modified_by: string;
}